import { Button, message, Switch } from "antd";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  getToggleData,
  toggleNotifications,
} from "../../../../../controller/services/common";
import i18n from "../../../../../localization/i18n";
import { setLoading } from "../../../../../redux/slices/common_slice";
import RightSideSettingsWrapper from "../../rightside-details-settings/RightSideSettingsWrapper";

const Notifications = () => {
  const { t } = useTranslation();
  const [isBroadcastChecked, setBroadcastChecked] = useState(false);
  const [isEmailChecked, setEmailChecked] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchToggleData();
  }, []);

  const fetchToggleData = async () => {
    try {
      dispatch(setLoading(true));
      const resp = await getToggleData();
      if (resp.status) {
        setBroadcastChecked(resp.data?.pushNotification);
        setEmailChecked(resp.data?.emailNotification);
      }
    } catch (error) {
      message.error(error.response.data?.message);
    } finally {
      dispatch(setLoading(false));
    }
  };
  const updateNotifications = async () => {
    try {
      dispatch(setLoading(true));
      const payload = {
        emailNotification: isEmailChecked,
        pushNotification: isBroadcastChecked,
        fcmToken: Cookies.get("fcmToken") || "",
      };
      const resp = await toggleNotifications(payload);
      message.success(resp.message[i18n.language]);
    } catch (error) {
      message.error(error.response.data?.message);
    } finally {
      dispatch(setLoading(false));
    }
  };
  return (
    <RightSideSettingsWrapper>
      <div className="row mx-0 settings-details-row">
        <div className="col-12 notification-data-column">
          <ul className="list-inline mb-0">
            <li>
              {t("settings.broadcast")}
              <Switch
                onChange={(checked) => setBroadcastChecked(checked)}
                checked={isBroadcastChecked}
              />
            </li>
            <li>
              {t("settings.email")}
              <Switch
                onChange={(checked) => setEmailChecked(checked)}
                checked={isEmailChecked}
              />
            </li>
          </ul>
        </div>
      </div>
      <div className="row mx-0 footer-settings-row">
        <Button onClick={updateNotifications}>Update</Button>
      </div>
    </RightSideSettingsWrapper>
  );
};

export default Notifications;
